module.exports = __webpack_public_path__ + "img/aimPoint4.eb66d28c.png";